export enum Flag {
  TEST = 'test',
  PMS_MODULE_CONTACT_PERSON_GRID = 'contact-person-ff',
  PMS_MODULE_COMPANY_GRID = 'p-2-pms-company-module',
  PMS_MODULE_GUEST_GRID = 'p-2-pms-guest-module',
  HOUSEKEEPING_TASKS = 'tasks-ff',
  HOUSEKEEPING_TEMPORARY_ASSIGNMENT_CREATE = 'housekeeping-temporary-assignment',
  HOUSEKEEPING_LOGIN_LINKS = 'housekeeping-permanent-assignment',
  PMS_SETTINGS_RESERVATION_ENABLED = 'pms-settings-reservation-enabled',
  FOLIO_DOCUMENTS_EDIT = 'edit-document-in-folio-p-2',
  INVOICING_DOCUMENTS_BATCH = 'p-2-documents-batch-flag',
  INVOICING_DOCUMENTS_MERGE_SPLIT = 'p-2-documents-split-merge-function',
  INVOICING_DOCUMENTS_ISSUE_RELATED = 'p-2-documents-issue-related-document',
  INVOICING_DOCUMENTS_CREATE_CURRENCY = 'p-2-documents-new-document-currency',
  INVOICING_GIFT_VOUCHERS_ENABLED = 'p-2-gift-vouchers',
  INVOICING_PAYMENT_PRESCRIPTIONS_ENABLED = 'p-2-payment-prescriptions',
  AUTOMATIC_REDIRECT_TO_P2_PMS_ENABLED = 'automatic-redirect-to-p-2-pms-enabled',
  CRM_SALES_CASES_IMPLEMENTATION = 'crm-sales-cases-implementation',
  PMS_COMMUNICATION_MODULE_ENABLED = 'pms-communication-module-enabled',
  PMS_COMMUNICATION_WHATSAPP_ENABLED = 'pms-communication-whatsapp-enabled',
  PMS_CONNECTED_ROOMS_ENABLED = 'pms-connected-rooms-enabled',
  PMS_RESERVATION_HISTORY = 'pms-reservation-history',
  PMS_RESERVATION_HISTORY_DETAIL = 'pms-reservation-history-detail',
  PMS_OFFERS_ENABLED = 'offers-in-p-2-calendar',
  PMS_SETTINGS_DASHBOARD_ENABLED = 'settings-dashboard',
  PMS_RESERVATIONS_OPTIMIZER_ENABLED = 'pms-reservations-optimizer-enabled',
  PMS_CLOSED_TERM_ALLOCATION_ENABLED = 'pms-closed-term-allocation-enabled',
  PMS_POS_TRANSACTION_WINDOW = 'p-2-pms-pos-transaction-window',
  PMS_EXCHANGE_RATES = 'pms-exchange-rates-module-enabled',
  PMS_TAX_SETTINGS_ENABLED = 'pms-tax-settings-enabled',
  MYCONNECTION_EDIT = 'myconnection-edit',
  PMS_SERVICE_MAPPING_ENABLED = 'pms-service-mapping-enabled',
  PMS_AGENT_ENABLED = 'pms-agent-enabled',
  PMS_RESERVATION_DETAIL_COMMUNICATION_TAB = 'p-2-pms-reservation-detail-communication-tab',
}
